import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, UtensilsCrossed } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";

export default function KitchenLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(username, password);
      if (data.role === "kitchen" || data.role === "admin") {
        toast.success("Welcome to Kitchen Display");
        navigate("/kitchen");
      } else {
        toast.error("Kitchen access required");
      }
    } catch (err) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-slate-800 mb-4">
            <UtensilsCrossed className="h-7 w-7 text-[#FF6347]" />
          </div>
          <h1
            className="text-2xl font-extrabold text-white"
            style={{ fontFamily: "Manrope" }}
          >
            Kitchen Display
          </h1>
          <p className="text-slate-400 text-sm mt-1">Sign in to view orders</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label className="text-slate-300 text-sm">Username</Label>
            <Input
              data-testid="kitchen-username-input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-1.5 h-12 rounded-xl bg-slate-800 border-slate-700 text-white placeholder:text-slate-500"
              placeholder="kitchen"
              required
            />
          </div>
          <div>
            <Label className="text-slate-300 text-sm">Password</Label>
            <Input
              data-testid="kitchen-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 h-12 rounded-xl bg-slate-800 border-slate-700 text-white placeholder:text-slate-500"
              placeholder="Enter password"
              required
            />
          </div>
          <Button
            data-testid="kitchen-login-btn"
            type="submit"
            className="w-full h-12 rounded-xl font-bold text-base"
            style={{ backgroundColor: "#FF6347" }}
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign In"}
            <Lock className="h-4 w-4 ml-2" />
          </Button>
        </form>
      </div>
    </div>
  );
}
